import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-container" }

import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter()

const goHome = () => {
  router.replace({ path: '/' })
}

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "title" }, "404", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Page not found", -1)),
    _createVNode(_component_el_link, {
      type: "primary",
      onClick: goHome
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Back to home")
      ])),
      _: 1,
      __: [0]
    })
  ]))
}
}

})